import * as React from 'react'

import { useHistoriesWidget } from './hooks'
import { History } from './types'
import { CBadge, CCard, CCardBody, CCardHeader } from '@coreui/react-pro'
import { Alert, Card } from 'antd'

type Props = {
  clientId: string
}

export const HistoriesWidget = ({ clientId }: Props) => {
  const { history } = useHistoriesWidget(clientId)

  return (
    <>
      <CCard>
        <CCardHeader>History</CCardHeader>
        <CCardBody>
          <HistoriesList items={history} />
        </CCardBody>
      </CCard>
    </>
  )
}

//

type HistoriesListProps = {
  items: History[] | undefined
}

const HistoriesList = ({ items }: HistoriesListProps) => {
  return (
    <>
      {items &&
        items?.length > 0 &&
        items?.map((item) => {
          return (
            <Card className="mb-2" key={item.requestId} title={item.updatedAt}>
              <p>reason: {item.reason}</p>
              <p>comment: {item.comment}</p>
              <p>documentNumber: {item.documentNumber}</p>
            </Card>
          )
        })}
    </>
  )
}
